export default __webpack_public_path__ + "static/media/painscale_9.fa2ee6a6.png";